import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css'; // Previously: './ShopMarketsRentals.css';
import Logo from '../assets/logo.svg';
import ScrollableFilter from '../components/ScrollableFilter'; // Dodaj import za novu komponentu
import ImageSlider from '../components/ImageSlider'; // Import komponente za slajder

const ShopMarketsRentals = () => {
    const { slug } = useParams(); // Dohvati slug iz URL-a
    const [places, setPlaces] = useState([]); // Podaci za prodavnice
    const [categories, setCategories] = useState([]); // Kategorije za filter
    const [filteredPlaces, setFilteredPlaces] = useState([]); // Filterovani rezultati
    const [activeFilter, setActiveFilter] = useState('All'); // Aktivni filter
    const [sliderImages, setSliderImages] = useState([]); // Slike za slajder
    const [coverImage, setCoverImage] = useState('/images/default.jpg'); // Default slika
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Dohvati kategorije prodavnica
                const categoriesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/shop-categories`);
                setCategories([{ name: 'All' }, ...categoriesResponse.data]);

                // Dohvati sve prodavnice vezane za ovaj smeštaj
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/shops-and-markets`);
                setPlaces(response.data);
                setFilteredPlaces(response.data); // Inicijalno svi podaci

                // Dohvati slike za slajder i cover image
                const accommodationResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
                );

                const images = accommodationResponse.data.slider_images
                    ? accommodationResponse.data.slider_images
                        .split(';')
                        .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`)
                    : [];

                if (images.length > 0) {
                    setSliderImages(images); // Ako postoje slike, koristi ih za slajder
                } else if (accommodationResponse.data.cover_image) {
                    // Ako nema slika za slajder, koristi cover_image
                    setCoverImage(`${process.env.REACT_APP_BACKEND_URL}/${accommodationResponse.data.cover_image}`);
                }

                setLoading(false);
            } catch (err) {
                console.error('Error fetching shops:', err);
                setError('Failed to load shops and markets.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        if (filter === 'All') {
            setFilteredPlaces(places); // Prikazuje sve
        } else {
            setFilteredPlaces(places.filter(place => place.category_name === filter));
        }
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontFamily: 'Montserrat, sans-serif',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
            }}>
                <img
                    src={Logo}
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }}
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!places.length) {
        return <p>No shops and markets available for this accommodation.</p>;
    }

    return (
        <div className="shops-page">
            <div className="header-slider">
                {sliderImages.length > 0 ? (
                    <ImageSlider images={sliderImages} />
                ) : (
                    <div
                        className="header-image"
                        style={{
                            backgroundImage: `url(${coverImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '300px',
                            width: '100vw',
                        }}
                    />
                )}
            </div>

            <div className="content-boxed">
                <div className="breadcrumb-container">
                    <p className="breadcrumb">
                        <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>                        

                        <span className="breadcrumb-divider"> &gt; </span>
                        <span className="current-page">Shops, Markets, and Rentals</span>
                    </p>
                </div>

                {/* Filter dugmadi */}
                <ScrollableFilter className="filter-section">
                    {categories.map((category, index) => (
                        <button
                            key={index}
                            className={category.name === activeFilter ? 'active' : ''}
                            onClick={() => handleFilterChange(category.name)}
                        >
                            {category.name}
                        </button>
                    ))}
                </ScrollableFilter>

                {/* Prikazivanje prodavnica */}
                <div className="gallery">
                    {filteredPlaces.map((place, index) => (
                        <Link
                            to={`/accommodations/${slug}/shops-and-markets/${place.id}`} // Prilagodjen link za restorane
                            className="gallery-item"
                            key={index}
                        >
                        <img 
                            src={place.image ? `${process.env.REACT_APP_BACKEND_URL}/${place.image}` : '/images/noimage.jpg'} 
                            alt={place.name || 'No name available'} 
                        />
                        <div className="place-info">
                            <h3>{place.name || 'No name available'}</h3>
                            <p><strong>Location:</strong> {place.location || 'Not specified'}</p>
                            <p><strong>Description:</strong> {place.description || 'No description available'}</p>
                        </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ShopMarketsRentals;
